import { FC } from 'react';
import { useParams } from 'react-router-dom';

import FundDealProgressChart from './FundDealProgressChart';
import GetStartedBannerForDealDashboard from './GetStartedBannerForDealDashboard';

const ManageDealForFund: FC = () => {
  const { fundId, dealId } = useParams<{ fundId: string; dealId: string }>() as {
    fundId: string;
    dealId: string;
  };

  return (
    <>
      <FundDealProgressChart dealId={dealId} />
      <GetStartedBannerForDealDashboard fundId={fundId} dealId={dealId} />
    </>
  );
};

export default ManageDealForFund;
